import { render, staticRenderFns } from "./UsersListing.vue?vue&type=template&id=20887d99&scoped=true"
import script from "./UsersListing.vue?vue&type=script&lang=js"
export * from "./UsersListing.vue?vue&type=script&lang=js"
import style0 from "./UsersListing.vue?vue&type=style&index=0&id=20887d99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20887d99",
  null
  
)

export default component.exports